import MapSection from './MapSection.jsx';

export default MapSection;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/MapSection/index.js